import {ValidationErrorProps as Props} from './ValidationError.type';

import cn from './ValidationError.module.scss';

export function ValidationError(props: Props) {
  if (!props.message) return <p className={cn.noValidation}></p>;
  return <p className={cn.errorMessage}>{props.message}</p>;
}
